export default __webpack_public_path__ + "static/4-4100690360e8b54337c70730726544b8.jpeg";